import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Collapse } from 'reactstrap';

import makeUrl from '../../../lib/makeUrl';
import LoadMore from './LoadMore';
import AddEntity from './AddEntity';
import Cards from '../Cards';

import '../ServiceModal/ServiceModal.css';
import { orderedArray, arrayForModal } from '../utils';

export default class DayTrailMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: props.first ? true : false,
    };
  }

  render() {
    const { patchInfo, editingPatchInfoId, route, region } = this.props;
    const isDraft = patchInfo.segmentId === editingPatchInfoId;
    const { collapse } = this.state;
    const { placeId, placeName } = patchInfo;
    return (
      <li>
        <div className="timeline-event">
          <div className="trail-mobile">
            <div className="timeline-label-not" onClick={this.toggleCollpase}>
              {route.segment_type === 'point' ? (
                <Link to={makeUrl.placeDetails(placeName, placeId, region)}>
                  {placeName.toUpperCase()}
                </Link>
              ) : (
                patchInfo.placeName.toUpperCase()
              )}
              <span>
                {collapse ? (
                  <i className="icon icon-hg-chev-up" />
                ) : (
                  <i className="icon icon-hg-chev-down" />
                )}
              </span>
            </div>
            <Collapse isOpen={collapse}>
              <div className="row">
                <div className="col-md-3 col-sm-12 col-12">
                  <LoadMore
                    lastComponent={
                      <AddEntity
                        patchInfo={patchInfo}
                        modalType={'trekDayModal'}
                        text="Add your own cards"
                      />
                    }
                    isDraft={isDraft}
                    elmId={`a${patchInfo.segmentId}`}
                  >
                    {this.renderEntities()}
                  </LoadMore>
                </div>
              </div>
            </Collapse>
            <hr />
          </div>
        </div>
      </li>
    );
  }

  renderEntities = () => {
    const { route, openSlider, setServiceModalConfig, patchInfo, date } = this.props;
    let sortedArray = [];
    let filteredArray = [];

    sortedArray = route.posters && orderedArray(route.posters);
    // const sightingsArray = sortedArray.filter(card => card.poster_type === "sightings");
    // const attractionsArray = sortedArray.filter(card => card.poster_type === "attractions");
    // const sidetripsArray = sortedArray.filter(card => card.poster_type === "sidetrips");
    filteredArray = arrayForModal(sortedArray);

    return sortedArray.map((entity, i) => {
      let slideIndex = '';
      // if (entity.poster_type === "sightings") {
      //   slideIndex = sightingsArray.indexOf(entity);
      // } else if (entity.poster_type === "attractions") {
      //   slideIndex = attractionsArray.indexOf(entity);
      // } else if (entity.poster_type === "sidetrips") {
      //   slideIndex = sidetripsArray.indexOf(entity);
      // }
      slideIndex = filteredArray.indexOf(entity);
      return (
        <div key={`${entity.id}+${i}`}>
          <Cards
            cardData={entity}
            theme={entity.poster_type}
            slideIndex={slideIndex}
            openSlider={openSlider}
            setServiceModalConfig={setServiceModalConfig}
            patchInfo={patchInfo}
            modalType="dayModal"
            placeName={patchInfo.placeName}
            dayDate={date}
          />
        </div>
      );
    });
  };

  toggleCollpase = () => {
    this.setState({ collapse: !this.state.collapse });
  };
}



// WEBPACK FOOTER //
// ./src/screens/Trek/DayTrail/DayTrailMobile.js